<template>
  <div class="page">
    <mu-toast v-if="toast" v-bind:message="hintMsg" @close="hideToast" id="alertline" />
    <mu-appbar style="height: 1rem">
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" style="margin-top: 0.05rem" slot="left" v-on:click="goback()" />
      <div style="text-align:center; font-size:0.38rem;margin-top:">新闻详情</div>

      <mu-icon value="keyboard_arrow_left" color="#27ba69" style="margin-bottom: -0.05rem" slot="right" />

    </mu-appbar>

    <!--主页面-->
    <div   v-if='!Isloading'  style="background-color:#fff ; min-height:12.4rem ; margin:auto auto ;  color:#666" id="Gxx1214"     >

      <img v-bind:src="AllInfo.Pic" style=" width:100% " />

      <!--<div style='height: 0.1rem;'></div>-->

      <div style='   background-color:#ddd ; line-height:2 ; padding-left:0.2rem ; font-weight:bolder ; margin-top:-0.1rem ; '>
        <div style=' font-size: 0.32rem '>{{AllInfo.Title}}</div>
      </div>
      <div style='    line-height:2 ; padding-left:0.2rem ; font-weight:bolder'>
        <div style=' font-size: 0.2rem '>来源：{{AllInfo.Author}}</div>
        <div style=' font-size: 0.2rem '>发布时间：{{AllInfo.Create_Time}}</div>
      </div>
      <div style='   background-color:#ddd ; height:0.2rem ; '>
      </div>

      
      <div v-html="HtmlCode" style = " width:95%;  margin:auto auto ;" >      </div>
      <div style='height: 1rem;'></div>


    </div>

    <div class='loading' style="background-color:white"  v-else>
      <div style='height: 0.7rem;background-color:white'></div>
      <img src="../../../static/LoadingBest.gif" />
    </div>


  </div>
</template>





<script>
import api from '../../api'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import loadListTail from '../../components/loadListTail'
import Scroll from '../../utils/loading'
export default {
  data() {
    return {
      HtmlCode:'',

      AllInfo :'',
      activeTab: '1',


      dialog: false,
      toast: false,



      loadState: [
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        }
      ],
      hintMsg: '',
      pageSize: 10,
      refreshing: false,
      trigger: null,
      couponCode: '',
      scroll: null,

      Isloading: true,


    }
  },
  activated() {
    this.Isloading=true;
    this.getData();

  },
  components: {
    loadListTail
  },
  methods: {
    ...mapMutations(['setG_currentOrder'
    ]),
    initData() {



    },

    // 后退一页
    goback() {
      javascript: history.go(-1);
    },


    //新闻单页    (int newsType, int pageSize, int pageIndex)
    getData() {
      var Tab = this.activeTab
      var that = this
      var params = new this.URLSearchParam();
      params.append('IDCode', this.$route.query.IDCode);
      //newsType  =  1 全部 23456 ~


      return new Promise(function(resolve, reject) {
        that.$http.post(api.GetNewsDetails(), params.toParam()).then((res) => {
          if (res.Result) {
            var temp = res.Data

            if (temp == null) {
              resolve(null)
            }
            else {

              // that.initFreeVOuchers(temp)
              resolve(temp.length)
              
              that.HtmlCode = res.Data.Content;        

              that.HtmlCode = that.HtmlCode.replace(/<img /g, "<img style='width:99%' ");

              that.AllInfo = res.Data

              that.Isloading = false;

            }
          }
          else {
            resolve(null)
            that.hintMsg = res.Message
            that.showToast()
          }
        })
      })

    },
    //三个分页
    handleTabChange(val) {

      this.activeTab = val;
      // this.scroll.changeType(val)
    },

    // 跳转页面+传参
    LookDetail(IDCode) {

    },




    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
      if (this.hintMsg == '请先登录') {
        console.log(this.hintMsg)
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1800)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },







  },
}
</script>







<style lang="less" scoped>
@import "../../assets/theme.less";

.mu-tabs {
  // 背景色
  background-color: #f5f5f5;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中  分页的
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换



</style>







// WEBPACK FOOTER //
// NewsDetailsPage.vue?634958f8